import React from "react";
import { RouteObject } from "react-router-dom";
import { lazy } from "react";
import Loadable from "../ui-components/Loadable";
import AuthGuard from "../guards/AuthGuard"; // Import AuthGuard
import Layout from "../ui-components/menus/layout/Layout";
// import Detail from "../views/pages/dashboard/detail";

const Dashboard = Loadable(
  lazy(() => import("../views/pages/dashboard/index"))
);

const FieldScreen = Loadable(
  lazy(() => import("../views/pages/dataEntry/fieldScreen"))
);

const DataEntry = Loadable(
  lazy(() => import("../views/pages/dataEntry/index"))
);

const ModelDataEntry = Loadable(
  lazy(() => import("../views/pages/dataEntry/dataList"))
);

const CompanyInfo = Loadable(
  lazy(() => import("../views/pages/companyInfo/index"))
);

const ModelParameterLabelConfiguration = Loadable(
  lazy(() => import("../views/pages/parameterConfiguration/parameterLabelConfiguration"))
);

const ParameterLabelConfiguration = Loadable(
  lazy(() => import("../views/pages/parameterConfiguration/index"))
);

const ModelCompanyInfo = Loadable(
  lazy(() => import("../views/pages/companyInfo/companyInfoDetail"))
);

const User = Loadable(lazy(() => import("../views/pages/user/userList")));

const Companies = Loadable(
  lazy(() => import("../views/pages/clientOrganization/index"))
);

const ChangePassword = Loadable(
  lazy(() => import("../views/pages/auth/changePassword"))
);

const Setup = Loadable(
  lazy(() => import("../views/pages/setup/index"))
);

const ModelDataSetup = Loadable(
  lazy(() => import("../views/pages/setup/modelDataSetup"))
);

const LogDataRecommendation = Loadable(lazy(() => import("../views/pages/recommendations/index")))

const Simulation = Loadable(
  lazy(() => import("../views/pages/simulation/SimulationListPage"))
);

const SimulationModelList = Loadable(
  lazy(() => import("../views/pages/simulation/SimulationModelListPage"))
);

const CreateSimulation = Loadable(
  lazy(() => import("../views/pages/simulation/SimulationWizardPage"))
);

// Define main routes with AuthGuard applied at the parent level
const MainRoutes: RouteObject = {
  path: "/",
  element: (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  ),
  children: [
    {
      path: "dashboard",
      element: <Dashboard />,
    },
    {
      path: "setup",
      element: <Setup />,
    },
    {
      path: "setup/:modelCode",
      element: <ModelDataSetup />,
    },
    {
      path: "changePassword",
      element: <ChangePassword />,
    },
    {
      path: "simulation/models",
      element: <SimulationModelList />,
    },
    {
      path: "simulation/:modelCode",
      element: <Simulation />,
    },
    {
      path: "simulation/create/:modelCode",
      element: <CreateSimulation />,
    },
    {
      path: "simulation/view/:modelCode/:simulationId",
      element: <CreateSimulation />,
    },
    {
      path: "simulation/dashboard/:simulationModelCode/:simulationId",
      element: <Dashboard />,
    },
    {
      path: "companyInfo",
      element: <CompanyInfo />,
    },
    {
      path: "companyInfo/:modelCode",
      element: <ModelCompanyInfo />,
    },
    {
      path: "dataList",
      element: <DataEntry />,
    },
    {
      path: "dataList/:modelCode",
      element: <ModelDataEntry />,
    },
    {
      path: "parameterLabelConfiguration",
      element: <ParameterLabelConfiguration />,
    },
    {
      path: "parameterLabelConfiguration/:modelCode",
      element: <ModelParameterLabelConfiguration />,
    },
    // {
    //   path: "recommendation/:modelCode/:logDate",
    //   element: <LogDataRecommendation />,
    // },
    // {
    //   path: "data/:id",
    //   element: <Detail />,
    // },
    //FOR EDITING LOG DATA 
    {
      path: "fieldScreen/:modelCode/:logDate",
      element: <FieldScreen />,
    },
    //FOR ADDING LOG DATA 
    {
      path: "fieldScreen/:modelCode",
      element: <FieldScreen />,
    },
    {
      path: "user",
      element: <User />,
    },
    {
      path: "companies",
      element: <Companies />,
    },
    // Other routes can go here (e.g., public routes)
  ],
};

export default MainRoutes;
